export const keyboardShortcuts = {
    data () {
        return {
            canvas: null
        }
    },
    mounted () {
        // Detect Keystrokes For Modifiers in Editor Mode
        document.addEventListener('keydown', (event) => {
            if (this.$store.state.mode === 'editor') {
                let target = (this.canvas.getActiveObject() === null) ? this.canvas.getActiveGroup() : this.canvas.getActiveObject()

                if (target !== undefined && target !== null) {
                    let move = (event.shiftKey === true) ? 10 : 1
                    if (event.altKey === true) {
                        move = 25
                    }

                    if (target.custom === undefined || target.custom.locked === undefined || target.custom.locked === false || target.isConnected === true) {
                        if (event.keyCode === 37) {
                            event.preventDefault()
                            if (target.isConnected === true) {
                                this.canvas.getActiveGroup().forEachObject((o) => {
                                    if (this.checkMaskUse(o)) {
                                        o.left -= move
                                    }
                                })
                                this.groupItemsRefresh(this.canvas.getActiveGroup())
                            } else {
                                target.left -= move
                            }
                        } else if (event.keyCode === 38) {
                            event.preventDefault()
                            if (target.isConnected === true) {
                                this.canvas.getActiveGroup().forEachObject((o) => {
                                    if (this.checkMaskUse(o)) {
                                        o.top -= move
                                    }
                                })
                                this.groupItemsRefresh(this.canvas.getActiveGroup())
                            } else {
                                target.top -= move
                            }
                        } else if (event.keyCode === 39) {
                            event.preventDefault()
                            if (target.isConnected === true) {
                                this.canvas.getActiveGroup().forEachObject((o) => {
                                    if (this.checkMaskUse(o)) {
                                        o.left += move
                                    }
                                })
                                this.groupItemsRefresh(this.canvas.getActiveGroup())
                            } else {
                                target.left += move
                            }
                        } else if (event.keyCode === 40) {
                            event.preventDefault()
                            if (target.isConnected === true) {
                                this.canvas.getActiveGroup().forEachObject((o) => {
                                    if (this.checkMaskUse(o)) {
                                        o.top += move
                                    }
                                })
                                this.groupItemsRefresh(this.canvas.getActiveGroup())
                            } else {
                                target.top += move
                            }
                        } else if (event.keyCode === 46) {
                            event.preventDefault()
                            this.removeElement()
                            this.selected = -1
                        }
                        this.canvas.renderAll()
                    }
                }

                if (event.metaKey === true) {
                    if (event.keyCode === 49) {
                        event.preventDefault()
                        this.addElement({type: 'text'})
                    } else if (event.keyCode === 50) {
                        event.preventDefault()
                        this.addElement({type: 'rect', custom: { name: 'New Rectangle' }})
                    } else if (event.keyCode === 51) {
                        event.preventDefault()
                        this.addElement({type: 'ellipse', custom: { name: 'New Ellipse' }})
                    } else if (event.keyCode === 52) {
                        event.preventDefault()
                        this.addElement({type: 'triangle', custom: { name: 'New Triangle' }})
                    } else if (event.keyCode === 53) {
                        event.preventDefault()
                        this.addElement({type: 'image'})
                    } else if (event.keyCode === 54) {
                        event.preventDefault()
                        this.addElement({type: 'clipping-area', custom: { name: 'Clipping Area', type: 'clipping-mask' }})
                    } else if (event.keyCode === 55) {
                        event.preventDefault()
                        this.addElement({type: 'round-clipping-area', custom: { name: 'Clipping Area', type: 'clipping-mask' }})
                    }
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/keyboardShortcuts.js